// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2ebu2","approved":"Status_approved__p1lCG","rejected":"Status_rejected__JIrFE","expired":"Status_expired__261w7","label":"Status_label__2IbWu"};